import React from "react";

const HourlyJobTable = ({ label = "Allow Minimum Compensation of", options = ["4 Hours", "8 Hours"], checked = false, onCheckChange, onOptionChange }) => {
  return (
    <div className="col-md-12">
      <div className="cp-split">
        <div className="hscommon-check">
          <input className="common-check" type="checkbox" id="hourlyComp" checked={checked} onChange={onCheckChange} />
          <label className="form-check-label" htmlFor="hourlyComp">
            {label} <span style={{ color: "red" }}>*</span>
          </label>
        </div>
        <select name="compHours" className="common-select" onChange={onOptionChange}>
          {options.map((opt, idx) => (
            <option key={idx} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default HourlyJobTable;